<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page"> <div class="bb-page-shell">
<!-- Header -->
<div class="bb-page-header">
  <div class="bb-page-title-block">
    <span class="bb-eyebrow">{{ "employees" | transloco }}</span>
    <h2 class="bb-page-title">{{ "employees" | transloco }}</h2>
    <p class="bb-page-subtitle">{{ "Manage your team members" | transloco }}</p>
  </div>

  <div class="bb-header-actions">
    <button routerLink="/addemployee" class="bb-btn bb-btn-primary">
      {{ "New employee" | transloco }}
    </button>

    @if(isAdmin){
    <div class="bb-action-dropdown dropdown">
      <button class="bb-btn bb-btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">
        {{ "Pospage" | transloco }}
      </button>

      <ul class="bb-dropdown-menu dropdown-menu">
        <li *ngFor="let el of allWareHouses">
          <a class="bb-dropdown-item dropdown-item" (click)="applyWareHouse(el.id)">
            {{el.name}}
          </a>
        </li>
      </ul>
    </div>
    }
  </div>
</div>

<!-- Card -->
<div class="bb-card bb-p-20">
  <div class="bb-table-scroll">
    <table mat-table [dataSource]="dataSource" class="bb-table table-custom mat-elevation-z0">

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
          {{ "Name" | transloco }}
        </th>

        <td mat-cell *matCellDef="let element" class="mat-cell-custom">
          <div class="bb-inline-flex bb-items-center bb-gap-12">
            <div class="bb-client-avatar">
              <img src="/assets/emploees.png" class="bb-w-100 bb-h-100 bb-rounded-full" />
            </div>

            <span class="bb-font-semibold bb-text-navy">
              {{ element.name }}
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="job_title">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
          {{ "job title" | transloco }}
        </th>

        <td mat-cell *matCellDef="let element" class="mat-cell-custom">
          <span class="bb-badge bb-badge-soft-blue">
            {{ element.job_title }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="salary">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
          {{ "salary" | transloco }}
        </th>

        <td mat-cell *matCellDef="let element" class="mat-cell-custom">
          <strong class="bb-price">
            {{ element.salary }} {{ "egp" | transloco }}
          </strong>
        </td>
      </ng-container>

      <ng-container matColumnDef="national_id">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
          {{ "grov_id" | transloco }}
        </th>

        <td mat-cell *matCellDef="let element" class="mat-cell-custom">
          {{ element.national_id || '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="phone">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
          {{ "phone" | transloco }}
        </th>

        <td mat-cell *matCellDef="let element" class="mat-cell-custom">
          {{ element.phone || '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
          {{ "address" | transloco }}
        </th>

        <td mat-cell *matCellDef="let element" class="mat-cell-custom">
          {{ element.address || '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="delete">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom bb-actions-th">
        </th>

        <td mat-cell *matCellDef="let element" class="mat-cell-custom bb-actions-td">
          <div class="bb-action-dropdown dropdown">
            <button
              class="bb-icon-btn action-btn menu"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              title="{{ 'Actions' | transloco }}"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <circle cx="12" cy="5" r="2" />
                <circle cx="12" cy="12" r="2" />
                <circle cx="12" cy="19" r="2" />
              </svg>
            </button>

            <ul class="bb-dropdown-menu dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
              <li>
                <a class="bb-dropdown-item dropdown-item" (click)='showEmployee(element)'>
                  {{ "employee details" | transloco }}
                </a>
              </li>

              <li *ngIf="!isSubAdmin">
                <a class="bb-dropdown-item dropdown-item" (click)='edit(element)'>
                  {{ "Edit" | transloco }}
                </a>
              </li>

              <li *ngIf="!isSubAdmin">
                <a class="bb-dropdown-item dropdown-item text-danger" (click)='deleteitem(element.id)'>
                  {{ "Delete" | transloco }}
                </a>
              </li>
            </ul>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="mat-header-row-custom"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="mat-row-custom"></tr>

    </table>
  </div>

  <mat-paginator
    [length]="totalItems"
    [pageSize]="10"
    (page)="onPaginateChange($event)"
    class="bb-paginator custom-paginator">
  </mat-paginator>
</div>
</div> </section>
